import {Outlet} from 'react-router-dom';

export const Box = ({children}: {children?: React.ReactNode}) => {
  return <>{children ?? <Outlet />}</>;
};
